import { image } from '../../../../../utils/data/baseUrl';

export default function Grade({ grade }) {
  const truthGrade = grade ?? 1;
  return (
    <div className={'achievement__lvl'}>
      <img src={image(`challenges/lvl-${truthGrade}.png`)} className={'achievement__lvl-image'} />
    </div>
  );
}
